import classNames from 'classnames';
import PratusTextArea from 'components/DesignSystems/New/PratusTextArea';
import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import { useUpsertIncidentStatusSummary } from 'components/IAP/hooks/incidentStatusSummaryHooks';
import { STATUS_SUMMARY_INCIDENT_TYPES } from 'components/IAP/ICSConstants';
import React from 'react';
import { Row } from 'react-bootstrap';

type IncidentTypeCheckboxGroupProps = {
  statusSummaryId?: string;
  originalIncidentType?: string[];
  originalOtherIncidentType?: string;
  readOnly?: boolean;
};

const IncidentTypeCheckboxGroup: React.FC<IncidentTypeCheckboxGroupProps> = ({
  statusSummaryId,
  originalIncidentType,
  originalOtherIncidentType,
  readOnly = false,
}) => {
  const [incidentTypes, setIncidentTypes] = React.useState<string[]>(
    originalIncidentType || []
  );

  const upsertIncidentStatusSummary =
    useUpsertIncidentStatusSummary(statusSummaryId);

  const handleChange = (value: string[]) => {
    setIncidentTypes(value);
    upsertIncidentStatusSummary({ incidentType: value });
  };

  return (
    <div className={classNames('mt-2', 'col-6')}>
      <label className="form-label">
        Type of Incident
        <span aria-label="Required field" className="required">
          *
        </span>
      </label>
      <div>
        {STATUS_SUMMARY_INCIDENT_TYPES.map((incidentType) => (
          <div key={incidentType.value} className="mb-1">
            <StylishNewCheckbox
              label={incidentType.label}
              checked={incidentTypes?.includes(incidentType.value) || false}
              disabled={readOnly}
              onChange={(e) => {
                const newValue = e.target.checked
                  ? [...(incidentTypes || []), incidentType.value]
                  : (incidentTypes || []).filter(
                      (v: string) => v !== incidentType.value
                    );
                handleChange(newValue);
              }}
            />
          </div>
        ))}
        {incidentTypes.includes('Other') && (
          <Row>
            <PratusTextArea
              label="Specify Other Incident Type"
              disabled={readOnly}
              onSave={(value) =>
                upsertIncidentStatusSummary({ otherIncidentType: value })
              }
              defaultValue={originalOtherIncidentType}
              maxLength={100}
            />
          </Row>
        )}
      </div>
    </div>
  );
};

export default IncidentTypeCheckboxGroup;
